import script from "./ServiceCardsLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./ServiceCardsLayout.vue?vue&type=script&lang=ts&setup=true"

import "./ServiceCardsLayout.vue?vue&type=style&index=0&id=74ed941e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74ed941e"]])

export default __exports__